'use strict';

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

exports.__esModule = true;

var Window = function Window(title, text, style) {
	_classCallCheck(this, Window);

	this.title = title;
	this.text = text;
	if (!style) {
		style = 'primary';
	}
	this.style = style;
	this.id = null;
};

exports['default'] = Window;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-modal/src/Window.js
 ** module id = 1051
 ** module chunks = 1
 **/